import { siteConfig } from '@/constants/site'
import { releaseSource } from '@/constants/release'

// The repository link falls back to the release repository, so setting either one is enough.
export const githubUrl = siteConfig.links.github || (releaseSource.githubRepo ? `https://github.com/${releaseSource.githubRepo}` : '')

export const documentationUrl = siteConfig.links.documentation

export const supportUrl = siteConfig.links.support
